import * as XLSX from "xlsx";
import * as React from "react";

// import { db } from "../firebaseConfig";
import {
  Timestamp
} from "firebase/firestore";

import {
  AddSingleDoc,
  QueryBusinesses,
  FixShortAddressForBusinesses
} from "../NetworkCalls/Admin/ServerReq";

export const BusinessAlreadyExists = async (collections, restaurantData) => {
  try {
    const businesses = await QueryBusinesses(collections, restaurantData["BUSINESS"], restaurantData["ADDRESS"])
    return !businesses.empty
  } catch (error) {
    console.log("RestaurantAlreadyExists error: " + error)
    return false;
  }
};

const ImportExcel = ({collections, apiData, setData, onSuccess}) =>{
  const [Loading, setLoading] = React.useState(false);
  const [TotalCount, setTotalCount] = React.useState(0);
  const [CurrentCount, setCurrentCount] = React.useState(0);

    const allowedExtensions = ["vnd.openxmlformats-officedocument.spreadsheetml.sheet"];
    const changeHandler = (e) => {
        const reader = new FileReader()
        reader.readAsBinaryString(e.target.files[0])
        reader.onload = async (e) => {

            const data = e.target.result
            const workbook = XLSX.read(data, {type: "binary"})

            setLoading(true)

            var importData = []

            for (const sheetName of workbook.SheetNames) {
              if (sheetName !== 'Chained Restaurants' && sheetName !== 'Count') {
                const sheet = workbook.Sheets[sheetName]
                const parsedData = XLSX.utils.sheet_to_json(sheet)

                importData = importData.concat(parsedData)
              }
            }

            if (!importData.empty) {
              setTotalCount(importData.length)

              var importCount = 0
              var skippedCount = 0
              var i = 1
              for (const restaurantData of importData) {
                setCurrentCount(i)

                const restaurantExists = await BusinessAlreadyExists(collections, restaurantData)
                if (!restaurantExists) {
                  // add phone prefix, if not provided
                  var phone = restaurantData["PHONE"] ?? ''
                  if (phone != '' && !phone.startsWith("1 ")) phone = "1 " + phone

                  const currentTimestamp = Timestamp.fromDate(new Date())

                  const restaurantId = await AddSingleDoc(collections, {
                    businessName: restaurantData["BUSINESS"] ?? '',
                    shortAddress: restaurantData["ADDRESS"] ?? '',
                    address:  restaurantData["ADDRESS"] + ', ' +
                              restaurantData["CITY"] + ', ' +
                              restaurantData["STATE"] + ' ' +
                              restaurantData["ZIP"] + ', United States',
                    city: restaurantData["CITY"] ?? '',
                    phone: phone ?? '',
                    state: restaurantData["STATE"] ?? '',
                    url: restaurantData["WEBSITE"] ?? '',
                    zip: restaurantData["ZIP"] ?? '',
                    createdAt: currentTimestamp,
                    updatedAt: currentTimestamp
                  })

                  importCount++
                } else {
                  skippedCount++
                }

                i++
              }

              setLoading(false)

              var importStatusMessage = "Imported " + importCount + " items"
              if (skippedCount > 0) importStatusMessage += " (skipped " + skippedCount + " items)"
              alert(importStatusMessage)

              onSuccess()
            } else {
              alert('Nothing to import')
            }
        }
    };

    return(
        <>
        <label style={{
    width:"100%",
      minWidth:"fit-content",
      border: `1px solid #410660`,
      color: "#fff",
      borderRadius: "60px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "0.5rem",
      textTransform: "capitalize",
      padding: "7px 16px",
      fontWeight: 500,
      fontSize: "14px",
      color: "#fff",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      backgroundColor: Loading ? "green" : "#410660",
      cursor: "pointer",
      marginLeft:'10px'
      }}
       for="import-csv">
        { Loading ? (CurrentCount > 0 ? CurrentCount + '/' + TotalCount : "In progress") : "Import" }
        </label>
        <input
        type="file"
        name="file"
        // accept=".xlxs"
        onChange={changeHandler}
        style={{ display: "block", margin: "10px auto" ,visibility:'hidden'}}
        id='import-csv'
      />
        </>
    )
}

export default ImportExcel;